import {
  getEventsGroupDetails
} from "./chunk-QQQ24EF2.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/events/groups.ts
import { useQuery } from "@tanstack/react-query";
var useGetEventsGroupDetails = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getEventsGroupDetails", props],
    queryFn: () => getEventsGroupDetails(props)
  }, options));
};

export {
  useGetEventsGroupDetails
};
//# sourceMappingURL=chunk-SFQBXT27.mjs.map